import { TRTCConnectionInfo } from "./trtc-def"
import { Button, Stack } from "react-bootstrap"
import { LoadingButton, ManagedInput } from "popopo-lib-front/component"
import { useZodForm } from "popopo-lib-front/zod-form"
import { zNonEmptyTextInput } from "popopo-lib-common"
import { z } from "zod/v4"
import { trtcAppId } from "../../core"

type Props = {
  defaultConnectionInfo?: Partial<TRTCConnectionInfo>
  handleSubmit: (connectionInfo: TRTCConnectionInfo) => Promise<void>
}

const schema = z.object({
  appId: zNonEmptyTextInput.pipe(z.coerce.number<string>().int()),
  userId: zNonEmptyTextInput,
  userSig: zNonEmptyTextInput,
  roomId: zNonEmptyTextInput,
  privateMapKey: zNonEmptyTextInput,
})

export function TRTCCallForm(props: Props) {
  const { control, handleSubmit, formState, setValue } = useZodForm({
    schema,
    defaultValues: {
      appId: props.defaultConnectionInfo?.appId ? String(props.defaultConnectionInfo.appId) : String(trtcAppId),
      userId: props.defaultConnectionInfo?.userId ?? "",
      userSig: props.defaultConnectionInfo?.userSig ?? "",
      roomId: props.defaultConnectionInfo?.roomId ?? "",
      privateMapKey: props.defaultConnectionInfo?.privateMapKey ?? "",
    },
  })

  const pasteJson = () => {
    const result = window.prompt("接続用JSONを貼り付けてください")

    if (result) {
      const json = JSON.parse(result) as Partial<TRTCConnectionInfo>
      if (json.appId) setValue("appId", String(json.appId))
      if (json.userId) setValue("userId", json.userId)
      if (json.userSig) setValue("userSig", json.userSig)
      if (json.roomId) setValue("roomId", json.roomId)
      if (json.privateMapKey) setValue("privateMapKey", json.privateMapKey)
    }
  }

  return (
    <form onSubmit={handleSubmit((e) => props.handleSubmit(e))}>
      <Stack gap={3}>
        <ManagedInput control={control} name={"appId"} label={"AppId"} />
        <ManagedInput control={control} name={"userId"} label={"UserId"} />
        <ManagedInput control={control} name={"userSig"} label={"UserSig"} />
        <ManagedInput control={control} name={"roomId"} label={"RoomId"} />
        <ManagedInput control={control} name={"privateMapKey"} label={"PrivateMapKey"} />

        <LoadingButton isLoading={formState.isSubmitting} isValid={formState.isValid}>
          接続する
        </LoadingButton>

        <Button className="btn-secondary" onClick={() => pasteJson()}>
          JSON貼り付け機能を利用
        </Button>
      </Stack>
    </form>
  )
}
